import { requestJson } from '../common/http';
import type { DayCell } from './models';

export const loadMonth = (year: number, month: number): Promise<DayCell[]> =>
    requestJson<DayCell[]>({
        method: 'GET',
        path: '/calendar/days',
        query: { year, month },
    });
